import type { PublicationItem } from 'components/discover/publications/model';
import { VideoPlayer } from 'components/discover/video/VideoPlayer';
import { FC, type PropsWithChildren, useRef } from 'react';
import styled from 'styled-components';

import { VideoPoster } from './video-poster';

type VideoContentProps = Readonly<{
  activeItem: PublicationItem;
  isPlaying: boolean;
  startPlaying: (videoTitle: string) => void;
  activeLabels: string[];
}>;

const StyledDiv = styled.div`
  aspect-ratio: 16/9;
`;

const VideoContainer: FC<PropsWithChildren<{}>> = ({ children }) => (
  <StyledDiv className="align-items-stretch flex-grow-1 flex-shrink-1">{children}</StyledDiv>
);

export const VideoContent: FC<VideoContentProps> = ({ activeItem, activeLabels, isPlaying, startPlaying }) => {
  const currentItem = useRef<PublicationItem>(null);
  const previousItem = useRef<PublicationItem>(null);

  const onPlay = () => startPlaying(activeItem?.title);

  if (currentItem.current !== activeItem) {
    (previousItem.current as any) = currentItem.current;
    (currentItem.current as any) = activeItem;
  }

  if (isPlaying && activeItem.videoId !== undefined) {
    return (
      <VideoContainer>
        <VideoPlayer className="position-absolute w-100" videoId={activeItem.videoId} />
      </VideoContainer>
    );
  }

  return (
    <VideoContainer>
      {previousItem.current !== null && (
        <VideoPoster active={false} item={previousItem.current} labels={activeLabels} />
      )}
      <VideoPoster active={true} item={activeItem} onPlay={onPlay} labels={activeLabels} />
    </VideoContainer>
  );
};
